import React from "react";
import WhyUs from "@/components/WhyUs";

export default function WhyPage() {
  return <WhyUs />;
}
